module.exports = __webpack_public_path__ + "img/bCase_TH.21ab0186.png";